import { ComponentClass, FunctionComponent } from 'react';

import HomePage from '@/views/core/HomePage';
import LoginPage from '@/views/core/Auth/LoginPage';
import MapPage from '@/views/core/MapPage';
import PasswordResetRequestPage from '@/views/core/Auth/PasswordResetRequestPage';
import PasswordResetPage from '@/views/core/Auth/PasswordResetPage';
import CommentsDataCentricPage from '@/views/Comments/CommentsDataCentricPage';
import ThreeDPage from '@/views/ThreeD/ThreeDPage';
import TenantsPage from '@/views/Tenants/TenantsPage';
import TenantPage from '@/views/Tenants/TenantPage';
import UsersPage from '@/views/Users/UsersPage';
import UserPage from '@/views/Users/UserPage';
import ModelsPage from '@/views/ModelsAdministration/ModelsPage';
import ModelPage from '@/views/ModelsAdministration/ModelPage';
import MapLayersPage from '@/views/MapLayersAdministration/MapLayersPage';
import MapLayerPage from '@/views/MapLayersAdministration/MapLayerPage';
import KomunalniObvezniciDataCentricPage from '@/views/Ena/KomunalniObvezniciPage/KomunalniObvezniciDataCentricPage';
import ObjektiPhotoCentricPage from '@/views/Ena/Objekti/ObjektiPhotoCentricPage';
import TranslatinoAdministrationPage from '@/views/TranslationAdministration/TranslatinoAdministrationPage';
import ProfilePage from '@/views/core/ProfilePage/ProfilePage';
import ThreeDAdminPage from '@/views/ThreeDAdministration/ThreeDAdminPage';
import ThreeDSettingAdminPage from '@/views/ThreeDAdministration/ThreeDSettingAdminPage';
import MapLegendsPage from '@/views/MapLegendsAdministration/MapLegendsPage';
import MapLegendPage from '@/views/MapLegendsAdministration/MapLegendPage';
import EnaSettingsPage from '@/views/EnaSettingsAdministration/EnaSettingsPage';
import EnaSettingPage from '@/views/EnaSettingsAdministration/EnaSettingPage';
import AppLogsPage from '@/views/AppLogsAdministration/AppLogsPage';
import RegistarProstornihPlanovaPage from '@/views/RegistarProstornihPlanova/RegistarProstornihPlanovaPage';
// import GrobnaMjestaDataCentricPage from '@/views/Groblja/old/GrobnaMjesta/GrobnaMjestaDataCentricPage';
import GrobnaMjestaPhotoCentricPage from '@/views/Groblja/GrobljaPhotodoc/GrobnaMjestaPhotoCentricPage';
import LoginLogsPage from '@/views/LoginLogsPage/LoginLogsPage';
import NerazvrstaneCesteMapCentricPage from '@/views/NerazvrstaneCeste/NerazvrstaneCestePage/NerazvrstaneCesteMapCentricPage';
import RasvjetaMjestaDataCentricPage from '@/views/Rasvjeta/RasvjetaMjestaPage/RasvjetaMjestaDataCentricPage';
import RasvjetaMjestaPhotoCentricPage from '@/views/Rasvjeta/RasvjetaPhotodoc/RasvjetaMjestaPhotoCentricPage';
import ParkingMjestaPhotoCentricPage from '@/views/Parking/ParkingMjestaPhotodoc/ParkingMjestaPhotoCentricPage';
import UserTenantsPage from '@/views/UserTenants/UserTenantsPage';
import UserTenantPage from '@/views/UserTenants/UserTenantPage';
import KuceZaOdmorDataCentricPage from '@/views/Ena/KuceZaOdmor/KuceZaOdmorDataCentricPage';
import CestePuteviDataCentricPage from '@/views/CestovnaInfrastruktura/CestePuteviPage/CestePuteviDataCentricPage';
import PoiDataCentricPage from '@/views/CestovnaInfrastruktura/PoiPage/PoiDataCentricPage';
import SearchSettingsPage from '@/views/SearchAdministration/SearchSettingsPage';
import AdministrationCommentsDataCentricPage from '@/views/CommentsAdministration/CommentsAdministrationDataCentricPage';
import NekretnineDataCentricPage from '@/views/Ena/PorezNaNekretnine/NekretnineDataCentricPage';
import ZalbePage from '@/views/Ena/Zalbe/ZalbePage';
import AktivnostiOdrzavanjaDataCentricPage from '@/views/CestovnaInfrastruktura/AKtivnostiOdrzavanjaPage/AktivnostiOdrzavanjaDataCentricPage';
import DynamicFormPage from '@/views/DynamicFormsAdministraion/DynamicFormPage';
import DynamicFormsPage from '@/views/DynamicFormsAdministraion/DynamicFormsPage';
import PPZahtjeviPage from '@/views/PP/PPZahtjeviPage';
import PPRegistarDataCentricPage from '@/views/PP/PPRegistarDataCentricPage';
import PPRegistarMapCentricPage from '@/views/PP/PPRegistarMapCentricPage';
import PPRegistarStatistikaPage from '@/views/PP/PPRegistarStatistikaPage';
import KoncesijeMapCentricPage from '@/views/Koncesije/KoncesijeMapCentricPage';
import ZatvaranjeVentilaPage from '@/views/Plin/ZatvaranjeVentilaPage';
import GradingPage from '@/views/Pristupacnost/GradingPage';
import POIPage from '@/views/Pristupacnost/POIPage';
import PopisGrobljaMapCentricPage from '@/views/Groblja/PopisGroblja/PopisGrobljaMapCentricPage';
import RegistarUmrlihPage from '@/views/Groblja/RegistarUmrlih/RegistarUmrlihPage';
import RegistarKremiranihPage from '@/views/Groblja/RegistarKremiranih/RegistarKremiranihPage';
import RegistarUkopanihPage from '@/views/Groblja/RegistarUkopanih/RegistarUkopanihMapCentricPage';
import RegistarKorisnikaDataCentricPage from '@/views/Groblja/RegistarKorisnika/RegistarKorisnikaDataCentricPage';
import RegistarGrobnihMjestaUkopaniMapCentricPage from '@/views/Groblja/RegistarGrobnihMjesta/RegistarGrobnihMjestaUkopaniDataCentricPage';
import RegistarGrobnihMjestaKorisniciMapCentricPage from '@/views/Groblja/RegistarGrobnihMjesta/RegistarGrobnihMjestaKorisniciDataCentricPage';
import RegistarPratecihGradevinaMapCentricPage from '@/views/Groblja/RegistarPratecihGradevina/RegistarPratecihGradevinaMapCentricPage';
import UpitnikPage from '@/views/Groblja/Upitnik/UpitnikPage';
import UpitnikTraziPage from '@/views/Groblja/Upitnik/UpitnikTraziPage';
import UpitniciMapCentricPage from '@/views/Groblja/Upitnici/UpitniciMapCentricPage';
import UpitnikOdgovoriMapCentricPage from '@/views/Groblja/UpitnikOdgovori/UpitnikOdgovoriMapCentricPage';

// Types
export type RouteType = {
  path: string;
  name: string;
  component: ComponentClass<any, any> | FunctionComponent<any>;
};

const routes: RouteType[] = [
  { path: '/', name: 'Home', component: HomePage },
  { path: '/login', name: 'Login', component: LoginPage },
  { path: '/map', name: 'Map', component: MapPage },
  { path: "/share", name: 'Map', component: MapPage },
  {
    path: '/password-reset-request',
    name: 'Password Reset Request',
    component: PasswordResetRequestPage,
  },
  {
    path: '/password-reset',
    name: 'Reset Password',
    component: PasswordResetPage,
  },
  {
    path: '/profile',
    name: 'Profile Page',
    component: ProfilePage,
  },
  {
    path: '/comments',
    name: 'Comments Management',
    component: CommentsDataCentricPage,
  },
  { path: '/3d', name: '3D', component: ThreeDPage },
  { path: '/admin/tenants', name: 'tenants', component: TenantsPage },
  {
    path: '/admin/tenants/:id',
    name: 'tenant',
    component: TenantPage,
  },
  {
    path: '/admin/users',
    name: 'users',
    component: UsersPage,
  },
  {
    path: '/user-tenants',
    name: 'user-tenants',
    component: UserTenantsPage,
  },
  {
    path: '/user-tenants/:id',
    name: 'user-tenant',
    component: UserTenantPage,
  },
  {
    path: '/admin/users/:id',
    name: 'user',
    component: UserPage,
  },
  {
    path: '/admin/translations',
    name: 'translations',
    component: TranslatinoAdministrationPage,
  },
  {
    path: '/admin/models',
    name: 'models',
    component: ModelsPage,
  },
  {
    path: '/admin/models/:id',
    name: 'model',
    component: ModelPage,
  },
  {
    path: '/admin/map_layers',
    name: 'map_layers',
    component: MapLayersPage,
  },
  {
    path: '/admin/map_layers/:id',
    name: 'map_layer',
    component: MapLayerPage,
  },
  {
    path: '/admin/3d_settings',
    name: '3d_settings',
    component: ThreeDAdminPage,
  },
  {
    path: '/admin/3d_settings/:id',
    name: '3d_setting',
    component: ThreeDSettingAdminPage,
  },
  {
    path: '/admin/map_legends',
    name: 'map_legends',
    component: MapLegendsPage,
  },
  {
    path: '/admin/registar-prostornih-planova',
    name: 'registar prostornih planova',
    component: RegistarProstornihPlanovaPage,
  },
  {
    path: '/admin/map_legends/:id',
    name: 'map_legend',
    component: MapLegendPage,
  },
  {
    path: '/admin/ena_settings',
    name: 'ena_settings',
    component: EnaSettingsPage,
  },
  {
    path: '/admin/ena_settings/:id',
    name: 'ena_setting',
    component: EnaSettingPage,
  },
  {
    path: '/admin/search_settings',
    name: 'search_settings',
    component: SearchSettingsPage,
  },
  {
    path: '/admin/app_logs',
    name: 'app_logs',
    component: AppLogsPage,
  },
  {
    path: '/admin/login_logs',
    name: 'login_logs',
    component: LoginLogsPage,
  },
  {
    path: '/ena/utility',
    name: 'Utility Obligations',
    component: KomunalniObvezniciDataCentricPage,
  },
  {
    path: '/ena/photodoc',
    name: 'Photo Documentation',
    component: ObjektiPhotoCentricPage,
  },
  {
    path: '/ena/kuce-za-odmor',
    name: 'Kuce Za Odmor',
    component: KuceZaOdmorDataCentricPage,
  },
  {
    path: '/ena/porez-na-nekretnine',
    name: 'Porez Na Nekretnine',
    component: NekretnineDataCentricPage,
  },
  {
    path: '/ena/zalbe',
    name: 'Žalbe',
    component: ZalbePage,
  },
  {
    path: '/pp/zahtjevi',
    name: 'Prostorni Plan Zahtjevi',
    component: PPZahtjeviPage,
  },
  {
    path: '/pp/registar',
    name: 'Registar Prostornih Planova',
    component: PPRegistarDataCentricPage,
  },
  {
    path: '/pp/registar-karta',
    name: 'Registar Prostornih Planova - Karta',
    component: PPRegistarMapCentricPage,
  },
  {
    path: '/pp/statistika',
    name: 'Statistika Registra Prostornih Planova',
    component: PPRegistarStatistikaPage,
  },
  {
    path: '/nerazvrstane-ceste',
    name: 'Nerazvrstane Ceste',
    component: NerazvrstaneCesteMapCentricPage,
  },

  /* {
    path: '/groblja/grobna-mjesta',
    name: 'Grobna Mjesta',
    component: GrobnaMjestaDataCentricPage,
  }, */
  {
    path: '/groblja/photodoc',
    name: 'Groblja Photo Documentation',
    component: GrobnaMjestaPhotoCentricPage,
  },

  {
    path: '/cestovna-infrastruktura/ceste-putevi',
    name: 'Ceste i putevi',
    component: CestePuteviDataCentricPage,
  },
  {
    path: '/cestovna-infrastruktura/tocke-interesa',
    name: 'Točke interesa',
    component: PoiDataCentricPage,
  },
  {
    path: '/cestovna-infrastruktura/aktivnosti-odrzavanja',
    name: 'Aktivnosti održavanja',
    component: AktivnostiOdrzavanjaDataCentricPage,
  },
  {
    path: '/groblja/popis-groblja',
    name: 'popis groblja',
    component: PopisGrobljaMapCentricPage,
  },
  {
    path: '/groblja/registar-umrlih',
    name: 'registar umrlih',
    component: RegistarUmrlihPage,
  },
  {
    path: '/groblja/registar-kremiranih',
    name: 'registar kremiranih',
    component: RegistarKremiranihPage,
  },
  {
    path: '/groblja/registar-ukopanih',
    name: 'registar ukopanih',
    component: RegistarUkopanihPage,
  },
  {
    path: '/groblja/registar-korisnika',
    name: 'registar korisnika',
    component: RegistarKorisnikaDataCentricPage,
  },
  {
    path: '/groblja/registar-grobnih-mjesta-ukopani',
    name: 'registar grobnih mjesta ukopani',
    component: RegistarGrobnihMjestaUkopaniMapCentricPage,
  },
  {
    path: '/groblja/registar-grobnih-mjesta-korisnici',
    name: 'registar grobnih mjesta korisnici',
    component: RegistarGrobnihMjestaKorisniciMapCentricPage,
  },
  {
    path: '/groblja/registar-pratecih-gradevina',
    name: 'registar pratecih gradevina',
    component: RegistarPratecihGradevinaMapCentricPage,
  },
  {
    path: '/groblja/upitnik',
    name: 'groblja upitnik trazi',
    component: UpitnikTraziPage,
  },
  {
    path: '/groblja/upitnik/:token',
    name: 'groblja upitnik',
    component: UpitnikPage,
  },
  {
    path: '/groblja/upitnici',
    name: 'groblja upitnici',
    component: UpitniciMapCentricPage,
  },
  {
    path: '/groblja/upitnici/odgovori',
    name: 'groblja upitnik odgovori',
    component: UpitnikOdgovoriMapCentricPage,
  },

  {
    path: '/rasvjeta/mjesta',
    name: 'Rasvjetna Mjesta',
    component: RasvjetaMjestaDataCentricPage,
  },
  {
    path: '/rasvjeta/photodoc',
    name: 'Rasvjeta Photo Documentation',
    component: RasvjetaMjestaPhotoCentricPage,
  },

  {
    path: '/parking',
    name: 'Parking Photo Documentation',
    component: ParkingMjestaPhotoCentricPage,
  },
  {
    path: '/admin/comments',
    name: 'Admin Comments',
    component: AdministrationCommentsDataCentricPage,
  },
  {
    path: '/admin/dynamic_forms',
    name: 'Admin Dynamic Forms',
    component: DynamicFormsPage,
  },
  {
    path: '/admin/dynamic_forms/:id',
    name: 'Admin Dynamic Form',
    component: DynamicFormPage,
  },
  {
    path: '/koncesije',
    name: 'Koncesije',
    component: KoncesijeMapCentricPage,
  },
  {
    path: '/plin/zatvaranje-ventila',
    name: 'Zatvaranje ventila',
    component: ZatvaranjeVentilaPage,
  },
  {
    path: '/pristupacnost/evaluacije',
    name: 'Evaluacije objekata',
    component: GradingPage,
  },
    {
    path: '/pristupacnost/poi',
    name: 'POI',
    component: POIPage,
  },
];

export default routes;
